import { render, staticRenderFns } from "./TendersList.vue?vue&type=template&id=1a69050d&scoped=true&"
import script from "./TendersList.vue?vue&type=script&lang=js&"
export * from "./TendersList.vue?vue&type=script&lang=js&"
import style0 from "./TendersList.vue?vue&type=style&index=0&id=1a69050d&lang=scss&scoped=true&"
import style1 from "./TendersList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a69050d",
  null
  
)

export default component.exports